import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getDateString, getRoundName } from '../common/RoundHelper';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { formatStringCurrency } from "../common/CurrencyFormatter";
import { ForwardArrowIcon } from "../reusable-components";
import { GetFlexNumber, GetMixMaxFlex, IsLeo, IsOrangeLight, IsVideo, UsePoolXLogoInRoundList, gradientsC, productNamesC, themeC } from '../theme/themehelper';
import { setOrigin, track } from '../analytics/analytics';
import { ChevronRight } from '../images/gogoicons';
import kung8 from '../images/kung8.png';
import kung12 from '../images/kung12.png';
import kung13 from '../images/kung13.png';
import video8back from '../images/video_8_background.png';
import video12back from '../images/video_12_background.png';
import video13back from '../images/video_13_background.png';
import video8 from '../images/video8_no_background.png';
import video12 from '../images/video12_no_background.png';
import video13 from '../images/video13_no_background.png';
import mrvegas8 from '../images/mrvegas_8.jpeg';
import mrvegas12 from '../images/mrvegas_12.jpeg';
import mrvegas13 from '../images/mrvegas_13.jpeg';
import mega8 from '../images/mega_8.png';
import mega12 from '../images/mega_12.png';
import mega13 from '../images/mega_13.png';
import comeon8 from '../images/comeon_8.png';
import comeon12 from '../images/comeon_12.png';
import comeon13 from '../images/comeon_13.png';
import comeon7 from '../images/comeon_7.png';
import comeon9 from '../images/comeon_9.png';
import snabbareBaseBackground from '../images/snabbare_base_background.png';
import snabbareSurvivorBackground from '../images/snabbare_survivor_bg.png';
import reviantBg from '../images/reviant.png';
import hajper8 from '../images/hajper_8.png';
import hajper12 from '../images/hajper_12.png';
import hajper13 from '../images/hajper_13.png';
import stuganBackground from '../images/stugan_background.png';
import hard13 from '../images/hard_13.png';
import hard12 from '../images/hard_12.png';
import hard8 from '../images/hard_8.png';
import hard9 from '../images/hard_hockey_9.png';
import hardSurvivor from '../images/hard_survivor_65.png';
import { EightIcon, ThirteenIcon, TwelveIcon } from "../reusable-components";
import { ShallowRound } from '../models/round';
import { getTheGameMatchName, isTheGameRoundName } from '../roundview/components/thegame/thegamemanifest';
import useTheGameManifest from '../roundview/components/thegame/usethegamemanifest';
import { DbetEightIcon, DbetEightLadder, DbetHockeyNineLogo, DbetSevenIcon, DbetSixIcon, DbetThirteenIcon, DbetThirteenLadder, DbetTwelveIcon, DbetTwelveLadder } from '../images/dbeticons';

function RoundHistoryItem({ active, round }: { active: boolean, round: ShallowRound }) {

  const { t } = useTranslation();
  const { id } = round;
  let friendlyName = getRoundName(round, t);
  const { manifest: theGameManifest } = useTheGameManifest(round);

  let link = `$/rounds/${id}`;

  const { operatorTurnover, operatorPrizePlan } = round || {};
  const { currency } = operatorTurnover || {};
  const isSmallScreen = useMediaQuery('(max-width: 580px)');
  const isVerySmallScreen = useMediaQuery('(max-width: 375px)');

  let highestWin = 0;
  let turnoverAmount = 0;

  if (operatorTurnover) {
    turnoverAmount = operatorTurnover.amount;
  }
  if (operatorPrizePlan) {
    const { payoutGroups } = operatorPrizePlan || {};
    if (payoutGroups && payoutGroups.length > 0) {
      highestWin = Math.max(...payoutGroups
        .map(group => group?.payoutPerRow?.money?.amount ?? 0));
    } else {
      console.error(`payout groups unavailable for round ${round.id}`)
    }
  }

  let statusLabel = '';
  let isLive = false;
  const now = new Date().getTime();
  const roundOpenTo = Date.parse(round.openTo.toString());
  if (round.status === 'ACTIVE') {
    statusLabel = t('round_status_open');

    if (now > roundOpenTo) {
      statusLabel = '';
      isLive = true;
    }
  }
  if (round.status === 'VOIDED') {
    statusLabel = t('round_status_voided');
  }
  if (round.status === 'PAUSED') {
    statusLabel = t('round_status_paused');
  }

  if (round.operatorTurnover === null || round.operatorTurnover === undefined) {
    return <></>;
  }

  let backGround = "#FFEE90";
  if (!active) {
    backGround = "#EDEDED";
  }

  let backgroundImage = '';
  let backgroundImageWidth = "100px";

  let borderRadius = '5px';
  let logo = '';
  let padding = '11px';
  let fontSize = '12px';
  let fontWeight = '500';
  let logoWidth = '71';
  let logoHeight = '35';
  let minMaxFlexTextColor = 'var(--text-white)';
  let numberImage = "";
  let numberBackgroundHeight = "64px";
  let numberBackgroundWidth = "77px";
  let icon = <></>;
  let fontFamily = 'var(--font-title)';
  let backgroundPosition = "auto";

  let mixMaxFlexStyle = {
    fontSize: "10px",
    fontFamily: 'var(--font-title)',
    color: 'var(--text-white)',
    fontWeight: "400",
    textTransform: "uppercase",
    marginTop: "0px"
  } 

  let mixMaxFlex: string = "";
  let number = GetFlexNumber(round.name);  
 

  if (window.theme === themeC.Orange) {
    logo = "none";
    mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = gradientsC.Orange.Flex;
    logoHeight = "50px";

    if (round.name.indexOf("Max") > -1) {
      mixMaxFlex = productNamesC.Orange.Max;
      number = "13";
      backgroundImage = gradientsC.Orange.Max;
    }
    if (round.name.indexOf("Mix") > -1) {
      mixMaxFlex = productNamesC.Orange.Mix;
      number = "12";
      backgroundImage = gradientsC.Orange.Mix;
    }
  }

  if (window.theme === themeC.GoGo) {
    logo = "none";
    mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = gradientsC.GoGo.Flex;
    logoHeight = "50px";

    if (round.name.indexOf("Max") > -1) {
      mixMaxFlex = productNamesC.Orange.Max;
      number = "13";
      backgroundImage = gradientsC.GoGo.Max;
    }
    if (round.name.indexOf("Mix") > -1) {
      mixMaxFlex = productNamesC.Orange.Mix;
      number = "12";
      backgroundImage = gradientsC.GoGo.Mix;
    }
  }

  if (window.theme === themeC.Wood) {
    logo = "none";
    mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = gradientsC.Wood.Flex;
    logoHeight = "50px";

    if (round.name.indexOf("Max") > -1) {
      mixMaxFlex = productNamesC.Orange.Max;
      number = "13";
      backgroundImage = gradientsC.Wood.Max;
    }
    if (round.name.indexOf("Mix") > -1) {
      mixMaxFlex = productNamesC.Orange.Mix;
      number = "12";
      backgroundImage = gradientsC.Wood.Mix;
    }
  }

  if (window.theme === themeC.Lion) {
    logo = "none";
    mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = "linear-gradient(135deg, #F18825 0%, #F18825 100%)"
    minMaxFlexTextColor = '#000';
    logoHeight = "50px";
    mixMaxFlexStyle.fontWeight = "600";
    mixMaxFlexStyle.textTransform = "none";
    mixMaxFlexStyle.color = "#000";

    if (round.name.indexOf("Max") > -1) {
      mixMaxFlex = productNamesC.Orange.Max;
      number = "13";
    }
    if (round.name.indexOf("Mix") > -1) {
      mixMaxFlex = productNamesC.Orange.Mix;
      number = "12";
    }
  }

  if (window.theme === themeC.Green) {
    logo = "none";
    mixMaxFlex = round.name.indexOf("Hockey") > -1 ? "Hockey" : "Rätt";
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = 'none';
    logoHeight = "50px";

    if (round.name.indexOf("Max") > -1) {
      mixMaxFlex = "Rätt";
      number = "13";
    }
    if (round.name.indexOf("Mix") > -1) {
      mixMaxFlex = "Rätt";
      number = "12";
    }
  }

  if (window.theme === themeC.ComeOn) {
    logo = "none";
    mixMaxFlex = "";
    number = "";
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '12px';
    fontWeight = '';
    backgroundImage = `url(${comeon8})`;
    logoHeight = "50px";
    logoWidth = "50px";
    backgroundImageWidth = '70px';
    backgroundPosition = "-23px";

    mixMaxFlexStyle.fontSize = '12px';
    mixMaxFlexStyle.fontFamily = 'Gravity';

    if (round.name.indexOf("7") > -1) {
      backgroundImage = `url(${comeon7})`;
    }
    if (round.name.indexOf("9") > -1) {
      backgroundImage = `url(${comeon9})`;
    }
    if (round.name.indexOf("Max") > -1) {
      backgroundImage = `url(${comeon13})`;
    }
    if (round.name.indexOf("Mix") > -1) {
      backgroundImage = `url(${comeon12})`;
    }
  }

  if (window.theme === themeC.Hajper) {
    logo = "none";
    mixMaxFlex = "";
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = `url(${hajper8})`;
    logoHeight = "50px";
    logoWidth = "70px";
    backgroundImageWidth = '80px';
    mixMaxFlexStyle.fontFamily = "HajperDisplay";

    if (round.name.indexOf("Max") > -1) {
      number = "13";
      backgroundImage = `url(${hajper13})`;
    }
    if (round.name.indexOf("Mix") > -1) {
      number = "12";
      backgroundImage = `url(${hajper12})`;
    }
  }

  if (window.theme === themeC.Snabbare) {
    logo = "none";
    mixMaxFlex = "Matcher";
    number = GetFlexNumber(round.name);
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = "";
    logoHeight = "50px";
    logoWidth = '68px';
    backgroundImageWidth = '68px';

    if (round.name.indexOf("7") > -1) {
      number = "7";
    }
    if (round.name.indexOf("9") > -1) {
      number = "9";
    }
    if (round.name.indexOf("Max") > -1) {
      number = "13";
    }
    if (round.name.indexOf("Mix") > -1) {
      number = "12";
    }
  }

  if (window.theme === themeC.Reviant) {
    logo = "none";
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '12px';
    fontWeight = '';
    backgroundImage = `url(${reviantBg})`;
    logoHeight = "50px";
    backgroundImageWidth = '70px';
    backgroundPosition = "-47px";
    borderRadius = '12px';
    mixMaxFlex = productNamesC.ComeOn.Flex;
    mixMaxFlexStyle.color = "#E71F00";

    if (round.name.indexOf("Max") > -1) {
      mixMaxFlex = productNamesC.ComeOn.Max;
      number = "13";
    }
    if (round.name.indexOf("Mix") > -1) {
      mixMaxFlex = productNamesC.ComeOn.Mix;
      number = "12";
    }
  }

  if (window.theme === themeC.Lyllo) {
    logo = "none";
    mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.ComeOn.Hockey : productNamesC.ComeOn.Flex;
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = gradientsC.Lyllo.Flex;
    logoHeight = "50px";
    borderRadius = 'var(--radius)';

    if (round.name.indexOf("Max") > -1) {
      mixMaxFlex = productNamesC.ComeOn.Max;
      number = "13";
      backgroundImage = gradientsC.Lyllo.Max;
    }
    if (round.name.indexOf("Mix") > -1) {
      mixMaxFlex = productNamesC.ComeOn.Mix;
      number = "12";
      backgroundImage = gradientsC.Lyllo.Mix;
    }
  }

  if (window.theme === themeC.Stugan) {
    logo = "none";
    mixMaxFlex = "Matcher";
    number = GetFlexNumber(round.name);
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    logoHeight = "50px";
    borderRadius = '0px';
    logoWidth = '68px';
    backgroundImageWidth = '68px';

    if (round.name.indexOf("Max") > -1) {
      number = "13";
    }
    if (round.name.indexOf("Mix") > -1) {
      number = "12";
    }
  }

  if (window.theme === themeC.Kryss) {
    logo = "none";
    mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Paf.Hockey : productNamesC.Paf.Flex;
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '12px';
    fontWeight = '';
    backgroundImage = gradientsC.Kryss.Flex;
    logoHeight = "50px";
    borderRadius = 'var(--radius)';

    if (round.name.indexOf("Max") > -1) {
      mixMaxFlex = productNamesC.Paf.Max;
      number = "13";
      backgroundImage = gradientsC.Kryss.Max;
    }
    if (round.name.indexOf("Mix") > -1) {
      mixMaxFlex = productNamesC.Paf.Mix;
      number = "12";
      backgroundImage = gradientsC.Kryss.Mix;
    }
  }

  if (window.theme === themeC.Hard) {
    logo = "none";
    backGround = 'var(--list-boxes-primary)';
    padding = '0px';
    fontSize = '12px';
    fontWeight = '';
    backgroundImage = round.name.indexOf("Hockey") > -1 ? `url(${hard9})` : `url(${hard8})`;
    logoHeight = "50px";
    borderRadius = 'var(--radius)';
    mixMaxFlex = "";
    number = "";

    if (round.name.indexOf("Max") > -1) {
      backgroundImage = `url(${hard13})`;
    }
    if (round.name.indexOf("Mix") > -1) {
      backgroundImage = `url(${hard12})`;
    }
    if (round.name.indexOf("Survivor") > -1) {
      backgroundImage = `url(${hardSurvivor})`;
      backgroundPosition = "center";
    }
  }

  if (UsePoolXLogoInRoundList(window.theme)) {
    borderRadius = 'var(--radius)';
    logo = "none";
    backGround = round.status === "FINISHED" ? 'var(--list-boxes-primary)' : 'var(--list-boxes-secondary)';
    padding = '8px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = "";
    logoHeight = "37px";
    icon = <EightIcon height="30px" />

    if (round.name.indexOf("Max") > -1) {
      mixMaxFlex = "Max";
      icon = <ThirteenIcon height="30px" />
    }
    if (round.name.indexOf("Mix") > -1) {
      mixMaxFlex = "Mix";
      icon = <TwelveIcon height="30px" />
    }
    numberImage = `url(${numberImage})`;
  }

  if (window.theme === themeC.Kung) {
    logo = "none";
    mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
    backGround = 'var(--background_4)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = gradientsC.Kung.Flex;
    logoHeight = "50px";
    minMaxFlexTextColor = "#27FFAA";
    numberImage = kung8;
    numberBackgroundHeight = "23px";
    numberBackgroundWidth = "17.35px";

    if (round.name.indexOf("Max") > -1) {
      backgroundImage = gradientsC.Kung.Max;
      minMaxFlexTextColor = "#34C2FF";
      numberImage = kung13;
      numberBackgroundHeight = "23px";
      numberBackgroundWidth = "27.5px";
    }
    if (round.name.indexOf("Mix") > -1) {
      backgroundImage = gradientsC.Kung.Mix;
      minMaxFlexTextColor = "#EE8DFF";
      numberImage = kung12;
      numberBackgroundHeight = "23px";
      numberBackgroundWidth = "28.46px";
    }
    numberImage = `url(${numberImage})`;
  }

  if (window.theme === themeC.Dbet) {
    logo = "none";
    mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
    backGround = 'var(--background_4)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = gradientsC.Dbet.Flex;
    logoHeight = "50px";
    minMaxFlexTextColor = "#F4C004";
    numberImage = "";
    numberBackgroundHeight = "23px";
    numberBackgroundWidth = "40px";
    fontFamily = "Righteous";
    icon = DbetEightIcon(23, 17.35);
    icon =
      <Grid container direction="row" alignItems="center" >
        <Grid sx={{ marginRight: "3.5px", paddingLeft: "8px" }}>
          {DbetEightIcon(23, 17.35)}
        </Grid>
        {DbetEightLadder(9.5, 5.6)}
      </Grid>

    if (round.name.indexOf("Survivor6") > -1) {
      icon =
        <Grid container direction="row" alignItems="center" >
          <Grid sx={{ marginRight: "3.5px", paddingLeft: "8px" }}>
            {DbetSixIcon(23, 17.35)}
          </Grid>
          {DbetEightLadder(9.5, 5.6)}
        </Grid>
    }
    if (round.name.indexOf("Hockey7") > -1) {
      icon =
        <Grid container direction="row" alignItems="center" >
          <Grid sx={{ marginRight: "3.5px", paddingLeft: "8px" }}>
            {DbetSevenIcon(23, 17.35)}
          </Grid>
          {DbetEightLadder(9.5, 5.6)}
        </Grid>
    }
    if (round.name.indexOf("Hockey9") > -1) {
      mixMaxFlex = "";
      numberBackgroundHeight = "40px";
      numberBackgroundWidth = "70px";
      icon =
        <Grid container alignItems="center" justifyContent="center" sx={{ height: "100%" }}>
          {DbetHockeyNineLogo(8, 70)}
        </Grid>
    }


    if (round.name.indexOf("Max") > -1) {
      backgroundImage = gradientsC.Dbet.Max;
      numberBackgroundHeight = "23px";
      numberBackgroundWidth = "50px";
      icon =
        <Grid container direction="row" alignItems="center" >
          <Grid sx={{ marginRight: "3.5px", paddingLeft: "8px" }}>
            {DbetThirteenIcon(23, 27.5)}
          </Grid>
          {DbetThirteenLadder(9.5, 5.6)}
        </Grid>
    }
    if (round.name.indexOf("Mix") > -1) {
      backgroundImage = gradientsC.Dbet.Mix;
      numberBackgroundHeight = "23px";
      numberBackgroundWidth = "50px";
      icon =
        <Grid container direction="row" alignItems="center" >
          <Grid sx={{ marginRight: "3.5px", paddingLeft: "8px" }}>
            {DbetTwelveIcon(23, 28.46)}
          </Grid>
          {DbetTwelveLadder(9.5, 5.6)}
        </Grid>
    }
    numberImage = `url(${numberImage})`;
  }

  if (window.theme === themeC.Video) {
    logo = "none";
    mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
    number = "8";
    backGround = 'var(--background_4)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = `url(${video8back})`;
    logoHeight = "50px";
    minMaxFlexTextColor = "#7EFFB2";
    numberImage = video8;
    numberBackgroundHeight = "31px";
    numberBackgroundWidth = "73.5px";
    fontFamily = "Tilt Warp";

    if (round.name.indexOf("Max") > -1) {
      backgroundImage = `url(${video13back})`;
      minMaxFlexTextColor = "#FFF3B7";
      numberImage = video13;
    }
    if (round.name.indexOf("Mix") > -1) {
      backgroundImage = `url(${video12back})`;
      minMaxFlexTextColor = "#D47EDD";
      numberImage = video12;
    }
    numberImage = `url(${numberImage})`;
  }

  if (window.theme === themeC.MrVegas) {
    logo = "none";
    mixMaxFlex = "";
    backGround = 'var(--background_4)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImage = `url(${mrvegas8})`;
    logoHeight = "50px";
    minMaxFlexTextColor = "#7EFFB2";
    numberBackgroundHeight = "31px";
    numberBackgroundWidth = "73.5px";
    fontFamily = "Tilt Warp";

    if (round.name.indexOf("Max") > -1) {
      backgroundImage = `url(${mrvegas13})`;
    }
    if (round.name.indexOf("Mix") > -1) {
      backgroundImage = `url(${mrvegas12})`;
    }
  }

  if (window.theme === themeC.Mega) {
    logo = "none";
    mixMaxFlex = "";
    backGround = 'var(--background_4)';
    padding = '0px';
    fontSize = '14px';
    fontWeight = '';
    backgroundImageWidth = '120px';
    backgroundImage = `url(${mega8})`;

    if (round.name.indexOf("Max") > -1) {
      backgroundImage = `url(${mega13})`;
    }
    if (round.name.indexOf("Mix") > -1) {
      backgroundImage = `url(${mega12})`;
    }
  }

  const smallText = {
    fontSize: fontSize,
    color: "var(--text-black-dark-background)",
    lineHeight: "18px",
    fontWeight: fontWeight,
    fontFamily: "var(--font-body)",
    width: isVerySmallScreen ? "80px" : "100px"
  };

  const smallTextCentered = {
    fontSize: fontSize,
    color: "var(--text-black-dark-background)",
    lineHeight: "18px",
    fontWeight: fontWeight,
    fontFamily: "var(--font-body)",
    textAlign: "center",
    width: isVerySmallScreen ? "80px" : "100px"
  };

  if (round.name.indexOf("Survivor") > -1) {
    mixMaxFlex = (window as any).theme === themeC.Green ? 'Stegen' : (window.theme === themeC.Hajper ? '' : t('survivor8'));
    number = GetFlexNumber(round.name);
  }

  // Hard/Bethard survivor: "Tipsraketen" is baked into the plate and there is no
  // round number on it, so blank the overlay text the generic block just set.
  if (round.name.indexOf("Survivor") > -1 && window.theme === themeC.Hard) {
    mixMaxFlex = "";
    number = "";
  }

  let dateText: string = getDateString(round, t);
  const ribbonTextWrap: CSSProperties = { whiteSpace: 'nowrap' };
  if (theGameManifest || isTheGameRoundName(round.name)) {
    mixMaxFlex = t('the_game');
    friendlyName = mixMaxFlex;
    if (theGameManifest) {
      dateText = `${getTheGameMatchName(theGameManifest)} · ${dateText}`;
    }
    number = "";
    numberImage = "";
    icon = <></>;
    backgroundImage = "none";
  }

  const reportSelection = () => {
    setOrigin("round_history", "round_list");
    track("select_content", { content_type: "round", content_id: "round_list" });
  }

  const isGoGoOrWood = window.theme === themeC.GoGo || window.theme === themeC.Wood;
  const isOrangeNewStyle = window.theme === themeC.Orange;
  const accentColor = window.theme === themeC.GoGo ? '#F14AA7' : '#B19661';
  const ribbonBg = window.theme === themeC.GoGo
    ? `linear-gradient(90deg, rgba(37,37,37,0.76) 0%, rgba(37,37,37,0.24) 100%), ${accentColor}`
    : `linear-gradient(90deg, rgba(30,30,30,0.76) 0%, rgba(30,30,30,0.24) 100%), ${accentColor}`;
  const themeFont = window.theme === themeC.GoGo ? "'Poppins'" : "'GT-America'";
  const ribbonFontWeight = window.theme === themeC.GoGo ? 400 : 700;
  const liveBadgeColor = window.theme === themeC.GoGo ? '#e53935' : '#D33C2D';
  const isSurvivor = round.name.indexOf("Survivor") > -1;

  if (isOrangeNewStyle) {
    const isTipsraketen = isSurvivor;
    const isLight = IsOrangeLight(window.theme);
    const orangeCardContent = (
      <div onClick={() => reportSelection()} style={{
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '48px',
          background: isLight
            ? (isTipsraketen ? 'linear-gradient(90deg, #FFF0E0 31.86%, #FFFFFF 100%)' : '#FFFFFF')
            : (isTipsraketen ? 'linear-gradient(90deg, #241D15 0%, #1E1E1E 30%)' : '#1E1E1E'),
          border: isTipsraketen ? '1px solid #FE8000' : isLight ? '1px solid #DDDDDD' : '1px solid #575757',
          boxShadow: '0px 1px 13px -2px rgba(16, 24, 40, 0.08)',
          borderRadius: '8px',
          overflow: 'hidden',
        }}>
          {/* Ribbon tag */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '8px 12px',
            width: '104px',
            minWidth: '104px',
            height: '48px',
            background: '#FE8000',
            borderRadius: '8px 0px 0px 8px',
          }}>
            <span style={{
              fontFamily: "'Hind'",
              fontWeight: 700,
              fontSize: '12px',
              lineHeight: '16px',
              textTransform: 'uppercase',
              color: isLight ? '#1F1F1F' : '#FFFFFF',
              textAlign: 'center',
              ...ribbonTextWrap,
            }}>
              {mixMaxFlex} {number}
            </span>
          </div>

          {/* Content card */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px 0px 8px 12px',
            gap: '8px',
            flex: 1,
            height: '48px',
          }}>
            <span style={{
              fontFamily: "'Hind'",
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '20px',
              color: isLight ? '#1F1F1F' : '#F0F0F0',
              flex: 1,
            }}>
              {dateText}
            </span>

            {isLive && (
              <div style={{
                border: '1px solid #ED2024',
                borderRadius: '4px',
                padding: '2px 8px',
                fontSize: '12px',
                fontWeight: 400,
                fontFamily: "'Hind'",
                color: '#ED2024',
                whiteSpace: 'nowrap',
                lineHeight: '16px',
              }}>
                {t('live')}
              </div>
            )}
            {statusLabel !== '' && !isLive && (
              <span style={{ fontFamily: "'Hind'", fontSize: '14px', color: isLight ? (isTipsraketen ? '#1F1F1F' : '#636363') : '#B3B3B3', whiteSpace: 'nowrap' }}>
                {statusLabel}
              </span>
            )}

            {/* Arrow */}
            <div style={{ padding: '0px 8px', display: 'flex', alignItems: 'center' }}>
              <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
                <path d="M1 1L6 6L1 11" stroke={isLight ? '#1F1F1F' : '#F0F0F0'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
    );

    return (
      <Link to={link} style={{ textDecoration: 'none' }}>
        <div style={{ marginTop: '8px' }}>
          {orangeCardContent}
        </div>
      </Link>
    );
  }

  if (window.theme === themeC.Lion) {
    const lionCardContent = (
      <div onClick={() => reportSelection()} style={{
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '48px',
          background: '#FFFFFF',
          border: '1px solid #DDDDDD',
          boxShadow: '0px 1px 13px -2px rgba(16, 24, 40, 0.08)',
          borderRadius: '8px',
          overflow: 'hidden',
        }}>
          {/* Ribbon tag */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '8px 12px',
            width: '104px',
            minWidth: '104px',
            height: '48px',
            background: '#FD5C3C',
            borderRadius: '8px 0px 0px 8px',
          }}>
            <span style={{
              fontFamily: "'Roboto'",
              fontWeight: 700,
              fontSize: '12px',
              lineHeight: '16px',
              textTransform: 'uppercase',
              color: '#1F1F1F',
              textAlign: 'center',
              ...ribbonTextWrap,
            }}>
              {mixMaxFlex} {number}
            </span>
          </div>

          {/* Content card */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px 0px 8px 12px',
            gap: '8px',
            flex: 1,
            height: '48px',
          }}>
            <span style={{
              fontFamily: "'Roboto'",
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '20px',
              color: '#1F1F1F',
              flex: 1,
            }}>
              {dateText}
            </span>

            {isLive && (
              <div style={{
                border: '1px solid #E60000',
                borderRadius: '4px',
                padding: '2px 8px',
                fontSize: '12px',
                fontWeight: 400,
                fontFamily: "'Roboto'",
                color: '#E60000',
                whiteSpace: 'nowrap',
                lineHeight: '16px',
              }}>
                {t('live')}
              </div>
            )}
            {statusLabel !== '' && !isLive && (
              <span style={{ fontFamily: "'Roboto'", fontSize: '14px', color: '#636363', whiteSpace: 'nowrap' }}>
                {statusLabel}
              </span>
            )}

            {/* Arrow */}
            <div style={{ padding: '0px 8px', display: 'flex', alignItems: 'center' }}>
              <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
                <path d="M1 1L6 6L1 11" stroke="#1F1F1F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
    );

    return (
      <Link to={link} style={{ textDecoration: 'none' }}>
        <div style={{ marginTop: '8px' }}>
          {lionCardContent}
        </div>
      </Link>
    );
  }

  if (isGoGoOrWood) {
    const woodBorder = '1px solid #575757';
    const gogoBorder = active ? `1px solid ${accentColor}` : '1px solid #575757';
    const cardBorder = isSurvivor ? 'none' : (window.theme === themeC.Wood ? woodBorder : gogoBorder);
    const cardBackground = isSurvivor
      ? 'linear-gradient(90deg, #1E1E1E 55.77%, #575757 100%)'
      : '#1E1E1E';
    const survivorBorderGradient = 'linear-gradient(134.7deg, #B79734 1.69%, #DDB95F 17.48%, #FDEDAC 28.15%, #DDB95F 36.05%, #B79734 47.66%, #575757 88.98%)';

    const cardContent = (
      <div onClick={() => reportSelection()} style={{
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: isSurvivor ? '46px' : '48px',
          background: cardBackground,
          border: cardBorder,
          boxShadow: isSurvivor ? 'none' : '0px 1px 13px -2px rgba(16, 24, 40, 0.08)',
          borderRadius: isSurvivor ? '7px' : '8px',
          overflow: 'hidden',
        }}>
          {/* Ribbon tag */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '8px 12px',
            width: '104px',
            minWidth: '104px',
            height: '48px',
            background: ribbonBg,
            borderRadius: '8px 0px 0px 8px',
          }}>
            <span style={{
              fontFamily: themeFont,
              fontWeight: ribbonFontWeight,
              fontSize: '12px',
              lineHeight: '16px',
              textTransform: 'uppercase',
              color: '#F0F0F0',
              textAlign: 'center',
              ...ribbonTextWrap,
            }}>
              {mixMaxFlex} {number}
            </span>
          </div>

          {/* Content card */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0px 0px 0px 12px',
            gap: '8px',
            flex: 1,
            height: '48px',
          }}>
            <span style={{
              fontFamily: themeFont,
              fontWeight: window.theme === themeC.GoGo ? 400 : 500,
              fontSize: '14px',
              lineHeight: '20px',
              color: '#F0F0F0',
              flex: 1,
            }}>
              {dateText}
            </span>

            {isLive && (
              <div style={{
                backgroundColor: liveBadgeColor,
                color: '#fff',
                borderRadius: '4px',
                padding: '2px 8px',
                fontSize: '11px',
                fontWeight: 700,
                fontFamily: themeFont,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                whiteSpace: 'nowrap',
              }}>
                {t('live')}
              </div>
            )}
            {statusLabel !== '' && !isLive && (
              <span style={{ fontFamily: themeFont, fontSize: '12px', color: '#B3B3B3', whiteSpace: 'nowrap' }}>
                {statusLabel}
              </span>
            )}

            {/* Arrow */}
            <div style={{ padding: '0px 12px 0px 16px', display: 'flex', alignItems: 'center' }}>
              <ChevronRight />
            </div>
          </div>
        </div>
    );

    return (
      <Link to={link} style={{ textDecoration: 'none' }}>
        {isSurvivor ? (
          <div style={{
            background: survivorBorderGradient,
            borderRadius: '8px',
            padding: '1px',
            boxShadow: '0px 1px 13px -2px rgba(16, 24, 40, 0.08)',
            marginTop: '8px',
          }}>
            {cardContent}
          </div>
        ) : (
          <div style={{ marginTop: '8px' }}>
            {cardContent}
          </div>
        )}
      </Link>
    );
  }

  return (
    <Link to={link} style={{ textDecoration: 'none' }}>
      <div onClick={() => reportSelection()}>
        <Grid container wrap="nowrap" justifyContent="space-between" alignItems="center" sx={{
          backgroundColor: backGround,
          marginTop: "10px",
          paddingTop: padding,
          paddingBottom: padding,
          borderRadius: borderRadius,
          ...(window.theme === themeC.Reviant && {
            border: '0.666667px solid rgba(0, 0, 0, 0.1)',
          }),
          ...(window.theme === themeC.Green && {
            '&:hover': { backgroundColor: '#F5FFFA' },
          }),
        }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between">
            {window.theme === 'gold' && <Typography sx={{
              fontSize: "12px",
              color: "#000000",
              lineHeight: "18px",
              fontWeight: "700",
              fontFamily: "var(--font-body)",
              width: "100px",
              marginLeft: "15px"
            }}>{friendlyName}</Typography>}

            {(IsLeo(window.theme) || IsVideo(window.theme) || UsePoolXLogoInRoundList(window.theme)) &&

              <Grid container direction='column' sx={{
                width: backgroundImageWidth,
                backgroundImage: backgroundImage,
                backgroundSize: 'cover',
                marginRight: window.theme === themeC.Green ? "0px" : "15px",
                justifyContent: 'center',
                height: "50px",
                backgroundPositionX: backgroundPosition,
                borderTopLeftRadius: borderRadius,
                borderBottomLeftRadius: borderRadius,
              }}>
                <Grid item sx={{
                  width: window.theme === themeC.Green ? '100px' : logoWidth,
                  height: logoHeight,
                  backgroundImage: logo !== 'none' ? `url(${logo})` : 'none',
                  backgroundSize: 'contain',
                  marginLeft: (window.theme === themeC.Green || window.theme === themeC.Stugan || window.theme === themeC.Snabbare) ? "0px" : "15px",
                  marginRight: (window.theme === themeC.Green || window.theme === themeC.Stugan || window.theme === themeC.Snabbare) ? "0px" : "15px",
                }}>                

                  {(IsLeo(window.theme) && window.theme !== themeC.Green && window.theme !== themeC.Stugan && window.theme !== themeC.Snabbare) &&
                    <Grid direction="column" container alignItems="center" sx={{ marginTop: "5px" }}>
                      <Typography sx={mixMaxFlexStyle}>
                        {mixMaxFlex}
                      </Typography>
                      <Typography sx={{
                        fontSize: "24px",
                        fontFamily: mixMaxFlexStyle.fontFamily,
                        color: mixMaxFlexStyle.color,
                        fontWeight: "800",
                        marginTop: window.theme === themeC.Hajper ? "3px" : "-5px"
                      }}>
                        {number}
                      </Typography>
                    </Grid>
                  }

                  {window.theme === themeC.Green &&
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100px',
                      height: '50px',
                      background: '#147B45',
                      borderRadius: '4px 0px 0px 4px',
                      gap: '2px',
                    }}>
                      <Typography sx={{
                        fontFamily: 'UnibetPro',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        fontSize: '32px',
                        lineHeight: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'center',
                        color: '#FFFFFF',
                      }}>
                        {number}
                      </Typography>
                      <Typography sx={{
                        fontFamily: 'UnibetPro',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        fontSize: '10px',
                        lineHeight: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'center',
                        color: '#FFFFFF',
                        textTransform: 'uppercase',
                      }}>
                        {mixMaxFlex}
                      </Typography>
                    </Box>
                  }

                  {window.theme === themeC.Stugan &&
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%', // inherits the Grid item's width (logoWidth)
                      height: '100%', // inherits the Grid item's height (logoHeight)
                      backgroundImage: `url(${stuganBackground})`,
                      backgroundSize: 'cover',
                      backgroundPositionX: '-25px',
                    }}>
                      {/* Stugan brand pinks (deliberate brand colors): number #FFDFDA also appears as tc.textOnRibbon in survivorcoupon.tsx; label #FDA89B is unique to this shield */}
                      <Typography sx={{
                        fontFamily: 'var(--font-title)',
                        fontSize: '24px',
                        fontWeight: 800,
                        color: '#FFDFDA',
                        lineHeight: 1,
                      }}>
                        {number}
                      </Typography>
                      <Typography sx={{
                        fontFamily: 'var(--font-title)',
                        fontSize: '8px',
                        fontWeight: 600,
                        // textTransform: 'uppercase',
                        color: '#FDA89B',
                        lineHeight: 1.2,
                      }}>
                        {mixMaxFlex}
                      </Typography>
                    </Box>
                  }

                  {window.theme === themeC.Snabbare &&
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%', // inherits the Grid item's width (logoWidth)
                      height: '100%', // inherits the Grid item's height (logoHeight)
                      backgroundImage: `url(${isSurvivor ? snabbareSurvivorBackground : snabbareBaseBackground})`,
                      backgroundSize: 'cover',
                      borderTopLeftRadius: borderRadius,
                      borderBottomLeftRadius: borderRadius,
                    }}>
                      <Typography sx={{
                        fontFamily: 'var(--font-title)',
                        fontSize: '24px',
                        fontWeight: 800,
                        color: '#FFFFFF',
                        lineHeight: 1,
                        fontStyle: 'normal',
                      }}>
                        {number}
                      </Typography>
                      <Typography sx={{
                        fontFamily: 'var(--font-title)',
                        fontSize: '7px',
                        fontWeight: 700,
                        color: '#FFFFFF',
                        lineHeight: 1.4,
                        textTransform: 'uppercase',
                        letterSpacing: '0.14em',   // restrained echo of the ribbon's wide tracking, sized for the tile
                        textIndent: '0.14em',      // balance the trailing space so it stays centered
                        fontStyle: 'normal',
                      }}>
                        {mixMaxFlex}
                      </Typography>
                    </Box>
                  }

                  {IsVideo(window.theme) &&
                    <Grid direction="column" container alignItems="center" sx={{ marginTop: "5px" }}>
                      <Typography sx={{
                        fontSize: "10px",
                        fontFamily: fontFamily,
                        color: minMaxFlexTextColor,
                        fontWeight: window.theme === themeC.Kung ? "700" : "400",
                        textTransform: window.theme === themeC.Video ? "none" : "uppercase",
                        marginTop: "0px"
                      }}>
                        {mixMaxFlex}
                      </Typography>
                      <Box
                        sx={{
                          backgroundImage: numberImage,
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                          height: numberBackgroundHeight,
                          width: numberBackgroundWidth,
                          marginTop: window.theme === themeC.Video ? "-8px" : ""
                        }}
                      >
                        {icon}
                      </Box>

                    </Grid>
                  }

                  {(UsePoolXLogoInRoundList(window.theme)) &&
                    <Grid direction="column" container alignItems="center" sx={{ marginTop: "5px" }}>
                      {icon}
                      <Box
                        sx={{
                          backgroundImage: numberImage,
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                          height: numberBackgroundHeight,
                          width: numberBackgroundWidth,
                        }}
                      ></Box>

                    </Grid>
                  }                  

                </Grid>
              </Grid>}

            <Typography sx={{ ...smallText, ...(window.theme === themeC.Green && { marginLeft: '12px' }) }}>{dateText}</Typography>
            {isLive &&
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  width: isVerySmallScreen ? "80px" : "100px",
                }}>
                <Box
                  sx={{
                    backgroundColor: '#e53935',
                    color: '#fff',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    fontSize: '11px',
                    fontWeight: 700,
                    fontFamily: 'var(--font-title)',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                  }}>
                  {t('live')}
                </Box>
              </Box>}

            {statusLabel !== "" && !isLive &&
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center">
                <Typography sx={active ? smallTextCentered : smallText}>{statusLabel}</Typography>
              </Box>}

            {(round.status === 'ACTIVE' || round.status === 'FINISHED') && !isSmallScreen &&
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center">
                <Typography sx={smallText}>{t('turnover')}:</Typography>
                <Typography sx={smallText}>{formatStringCurrency(turnoverAmount, currency, t, true)}</Typography>
              </Box>}

            {statusLabel === "" && !isLive &&
              <Box
                display="flex"
                flexDirection="column"
                justifyContent='center'
                alignItems="center">
                <Typography sx={smallText}>{t('highest_win')}:</Typography>
                <Typography sx={smallText}>{formatStringCurrency(highestWin, currency, t, true)}</Typography>
              </Box>}
          </Box>
          <Grid sx={{ paddingRight: "10px" }}>
            {ForwardArrowIcon("var(--text-black-dark-background)")}
          </Grid>
        </Grid>
      </div>
    </Link>
  );

}
export default RoundHistoryItem;
